import { render, staticRenderFns } from "./testimonials.vue?vue&type=template&id=73a56d96&scoped=true&"
import script from "./testimonials.vue?vue&type=script&lang=js&"
export * from "./testimonials.vue?vue&type=script&lang=js&"
import style0 from "./testimonials.vue?vue&type=style&index=0&id=73a56d96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a56d96",
  null
  
)

export default component.exports